module.exports = __webpack_public_path__ + "img/portrait-051.d171a547.jpg";